module.exports = __webpack_public_path__ + "static/media/Colette Queen Bed Base - 155x205 cm_Black.45be4e5f.png";